module.exports = __webpack_public_path__ + "img/mail.db3bb306.svg";